import { StepModel } from "@common/components/dotLegalStepper/DotLegalCoreStepper.types";
import { useSteps } from "@common/components/dotLegalStepper/useSteps";
import { EntityTemplate } from "../../entityTemplates/EntityTemplate.types";
import { hasFieldData } from "../../entityTemplates/fieldValue";
import { LegalEntityFieldModel } from "../../entityTemplates/LegalEntityFieldRenderers";
import { getLegalEntityFieldValue } from "./EditLegalEntityValidator.hooks";

export function useEditLegalEntitySteps(
    legalEntity: LegalEntityFieldModel | undefined,
    legalEntityTemplate: EntityTemplate | undefined,
    legalEntitySteps: Array<StepModel>,
    selectedTags: Array<string>
) {
    const steps = useSteps(legalEntity, legalEntitySteps, "step", hasStepDataAdded);

    function hasStepDataAdded(step: number) {
        if (!legalEntityTemplate || !legalEntity) {
            return false;
        }

        const templateStep = legalEntityTemplate.steps.find((x) => x.order === step);

        return !!templateStep?.fields.some((field) => hasFieldData(getLegalEntityFieldValue(field, legalEntity, selectedTags)));
    }

    return {
        getSteps: steps.getTemplateSteps,
        getActiveStep: steps.getActiveStep,
        changeStep: steps.changeStep,
        validationErrors: steps.validationErrors,
    };
}
